import styled from "styled-components";

export const ImageStyle = styled.img<{ height: string }>`
  background: transparent;
  height: ${(props) => props.height};
`;
